import dayjs from 'dayjs';

import Course from '../../course/types/Course';
import User from '../../user/types/User';
import { OpenClass, OpenClassStatus } from '../types/OpenClass';

export type OpenClassFilterValues = {
  courseIds?: Course['id'][];
  endsAt?: string;
  instructorIds?: User['id'][];
  startsAt?: string;
  status?: OpenClassStatus[];
};

const startsBeforeRangeEnds = (openClass: OpenClass, endsAt: string) =>
  !dayjs(openClass.startAt).isAfter(dayjs(endsAt));

const endsAfterRangeStarts = (openClass: OpenClass, startsAt: string) =>
  dayjs(openClass.endAt).isAfter(dayjs(startsAt));

const hasInstructor = (openClass: OpenClass, instructorIds: User['id'][]) =>
  openClass.sessions.some((session) =>
    session.instructors.some(({ id }) => instructorIds.includes(id)),
  );

export const filterOpenClasses = (
  openClasses: OpenClass[],
  filter: OpenClassFilterValues,
): OpenClass[] =>
  openClasses.filter((openClass) => {
    if (
      filter.courseIds?.length &&
      !filter.courseIds.includes(openClass.course.id)
    ) {
      return false;
    }
    if (filter.status?.length && !filter.status.includes(openClass.status)) {
      return false;
    }
    if (
      filter.instructorIds?.length &&
      !hasInstructor(openClass, filter.instructorIds)
    ) {
      return false;
    }
    if (filter.startsAt && !endsAfterRangeStarts(openClass, filter.startsAt)) {
      return false;
    }
    if (filter.endsAt && !startsBeforeRangeEnds(openClass, filter.endsAt)) {
      return false;
    }
    return true;
  });
